<div class="tank-debunker">
  <div class="reorder">
    <re-reorder-buttons (reorder)="onReorder($event)" />
  </div>

  <div class="delete">
    <re-trash-button (delete)="onDelete()" />
  </div>

  <h2 class="transfer-header text-center">Debunker</h2>
  <div class="container">
    <div class="tank">
      <re-tank-summary
        [tank]="from"
        [progress]="fromProgress"
        [progress2]="progress2"
        [tankNumber]="1"
        [tankName]="'HFO (L)'"
        [fuelGrade]="'HFO'"
        [quantity]="from.content!.quantity - debunkerAmount"
      />
    </div>

    <div class="debunker-amount">
      <input
        (input)="onInputChange()"
        [(ngModel)]="debunkerAmount"
        [min]="0"
        [max]="maxDebunkerAmount"
        (ngModelChange)="onModelChange()"
        type="number"
        name="transfer-amount"
        placeholder="0"
      />
      MT

      <div class="empty">
        <button
          class="rounded-sm bg-indigo-700 px-1"
          (click)="onEmptyTank()"
        >
          Empty Tank
        </button>
      </div>
    </div>
  </div>
</div>
